import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@admin-env/environment';
import isNonNil from '../../helpers/is-not-nil';
import { StorageService } from '../storage.service';

export abstract class ApiBase {
  protected abstract model: string;
  protected get modelBase() {
    return `${this.apiBase}/${this.model}`;
  }
  protected readonly apiBase = environment.BASE_PATH;

  constructor(protected http: HttpClient, protected storage: StorageService) {}

  modelUri(id: string) {
    return `${this.modelBase}/${id}`;
  }

  buildUrl(...path: string[]) {
    if (!path.length) return `${this.modelBase}`;
    return `${this.modelBase}/${path.join('/')}`;
  }

  setParams(paramsTemplate: {
    [key: string]: string | number | undefined | string[];
  }) {
    let params = new HttpParams();
    for (const key in paramsTemplate) {
      if (isNonNil(paramsTemplate[key])) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const element = paramsTemplate[key]!;
        params =
          typeof element === 'string'
            ? params.set(key, element)
            : params.set(key, element.toString());
      }
    }
    return params;
  }

  setHeaders(headerTemplate: { [key: string]: string }) {
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    for (const key in headerTemplate) {
      if (isNonNil(headerTemplate[key])) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const element = headerTemplate[key]!;
        headers = headers.set(key, element);
      }
    }
    return headers;
  }

  getStorage() {
    return this.storage;
  }
}
